import Logo from './components/icons/Logo'
import ArrowLeftIcon from './components/icons/ArrowLeft'
import PlusIcon from './components/icons/Plus'
import SearchIcon from './components/icons/Search'
import CopyIcon from './components/icons/Copy'
import UserIcon from './components/icons/User'
import LockIcon from './components/icons/Lock'
import DashboardIcon from './components/icons/Dashboard'
import CollageIcon from './components/icons/Collage'
import StoreIcon from './components/icons/Store'
import ClientsIcon from './components/icons/Clients'
import UsersIcon from './components/icons/Users'
import ChevronRightIcon from './components/icons/ChevronRight'
import ChevronDownIcon from './components/icons/ChevronDown'
import EditIcon from './components/icons/Edit'
import StatsIcon from './components/icons/Stats'
import SettingsIcon from './components/icons/Settings'
import LinkIcon from './components/icons/Link'
import CreateLinkIcon from './components/icons/CreateLink'
import ConvertLinkIcon from './components/icons/ConvertLink'
import TrashIcon from './components/icons/Trash'
import ManualIcon from './components/icons/Manual'
import PackageIcon from './components/icons/Package'
import CrossIcon from './components/icons/Cross'
import HeartIcon from './components/icons/Heart'
import AlertIcon from './components/icons/Alert'
import AlertArea from './components/AlertArea'
import LogoutIcon from './components/icons/Logout'
import Faq from './components/icons/Faq'
import EmptyImage from './components/icons/EmptyImage'
import TikTok from './components/icons/TikTok'
import YouTube from './components/icons/YouTube'
import MediaIcon from './components/icons/MediaIcon'
import ZezamLoginBtn from '@/components/ZezamLoginBtn.vue'

export const registerGlobalComponents = (app) => {
  app.component('Logo', Logo)
  app.component('ArrowLeftIcon', ArrowLeftIcon)
  app.component('PlusIcon', PlusIcon)
  app.component('SearchIcon', SearchIcon)
  app.component('CopyIcon', CopyIcon)
  app.component('UserIcon', UserIcon)
  app.component('LockIcon', LockIcon)
  app.component('DashboardIcon', DashboardIcon)
  app.component('CollageIcon', CollageIcon)
  app.component('StoreIcon', StoreIcon)
  app.component('ClientsIcon', ClientsIcon)
  app.component('UsersIcon', UsersIcon)
  app.component('ChevronRightIcon', ChevronRightIcon)
  app.component('ChevronDownIcon', ChevronDownIcon)
  app.component('EditIcon', EditIcon)
  app.component('StatsIcon', StatsIcon)
  app.component('SettingsIcon', SettingsIcon)
  app.component('LinkIcon', LinkIcon)
  app.component('CreateLinkIcon', CreateLinkIcon)
  app.component('ConvertLinkIcon', ConvertLinkIcon)
  app.component('TrashIcon', TrashIcon)
  app.component('ManualIcon', ManualIcon)
  app.component('PackageIcon', PackageIcon)
  app.component('CrossIcon', CrossIcon)
  app.component('HeartIcon', HeartIcon)
  app.component('AlertIcon', AlertIcon)
  app.component('LogoutIcon', LogoutIcon)
  app.component('AlertArea', AlertArea)
  app.component('FaqIcon', Faq)
  app.component('EmptyImageIcon', EmptyImage)
  app.component('TiktokIcon', TikTok)
  app.component('YoutubeIcon', YouTube)
  app.component('MediaIcon', MediaIcon)
  app.component('ZezamLoginBtn', ZezamLoginBtn)
}
